<template>
  <div class="tabs">
    <input
      class="input"
      name="tabs"
      type="radio"
      id="tab-1"
      :checked="todaysData.length > 0 && true"
      v-if="todaysData.length > 0"
    />
    <label class="label" for="tab-1" v-if="todaysData.length > 0">{{
      todays_date
    }}</label>
    <div class="panel">
      <timelineJadualMobile :data="todaysData" v-if="todaysData.length > 0" />
      <div class="w-100" v-else>
        <p class="no-record-title">Tiada rekod dijumpai</p>
      </div>
    </div>
    <input
      class="input"
      name="tabs"
      type="radio"
      id="tab-2"
      v-if="tomorrowsData.length > 0"
    />
    <label class="label" for="tab-2" v-if="tomorrowsData.length > 0"
      >Esok</label
    >
    <div class="panel">
      <timelineJadualMobile
        :data="tomorrowsData"
        v-if="tomorrowsData.length > 0"
      />
      <div class="w-100" v-else>
        <p class="no-record-title">Tiada rekod dijumpai</p>
      </div>
    </div>
    <input
      class="input"
      name="tabs"
      type="radio"
      id="tab-3"
      :checked="todaysData.length === 0 && true"
    />
    <label class="label" for="tab-3">Saluran TV</label>
    <div class="panel">
      <div class="container-fluid mt-3" style="height: fit-content !important;">
        <div class="row">
          <span class="rails-header-title mb-2">Saluran Feeling Feeling</span>
        </div>
        <div class="row">
          <div
            class="col-6 px-1 my-1"
            v-for="item_vod in tv_fast_channel_list"
            :key="item_vod.id"
            @mouseover="mouseOver"
            @mouseout="mouseOver"
          >
            <tv-card :image="item_vod.img_link" :link="item_vod.redirect_url" />
          </div>
        </div>
      </div>
      <div class="container-fluid mt-3" style="height: fit-content !important;">
        <div class="row">
          <span class="rails-header-title mb-2">Saluran TV</span>
        </div>
        <div class="row">
          <div
            class="col-6 px-1 my-1"
            v-for="item_vod in tv_list"
            :key="item_vod.id"
            @mouseover="mouseOver"
            @mouseout="mouseOver"
          >
            <tv-card :image="item_vod.img_link" :link="item_vod.redirect_url" />
          </div>
        </div>
      </div>
      <div class="w-100 px-0 mt-4">
        <saluranKhas class="my-3" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue';
import saluranKhas from '../../components/carousel/vod/v2/saluranTV.vue';
import tvFastChannelRails from '../../components/carousel/homepage/v2/tvFastChannelRails.vue';
import timelineJadualMobile from './timelineJadualMobile.vue';
import tvCard from '../cards/v2/tvCard.vue';
export default {
  name: 'vodTabsMobile',
  props: ['todaysData', 'tomorrowsData', 'todays_date'],
  data: function() {
    return {
      tv_list: [],
      tv_fast_channel_list: [],
      hover: false,
    };
  },
  components: {
    saluranKhas,
    tvCard,
    timelineJadualMobile,
    // tvFastChannelRails,
  },

  created: function() {
    this.$store.dispatch('fetchRTMTVList', { self: this });
    this.$store.dispatch('fetchRTMTVFastChannelList', { self: this });
  },
  methods: {
    mouseOver: function() {
      this.hover = !this.hover;
    },
    goTo() {
      this.$router.push('/live/tv1');
    },
    filterTVList() {
      var vm = this;
      vm.tv_list = this.$store.state.tv_list.data;
      var store = [];
      vm.tv_list.forEach((item) => {
        // var timecompare = this.formatTimestamp(item.dateAvailability);
        if (item.id.toString() !== '7' || item.id.toString() !== '8') {
          item['img_link'] = this.rtmImgLinkFiltering(
            item.data.images,
            '320x0'
          );
          item['redirect_url'] = `/live/${this.lowerCaseAndRemoveSpace(
            item.longTitle
          )}`;
          store.push(item);
        }
      });

      vm.tv_list = store.slice(0, 6);
    },

    filterTVFastChannelList() {
      var vm = this;
      vm.tv_fast_channel_list = this.$store.state.tv_fast_channel_list.data;
      var store = [];
      vm.tv_fast_channel_list.forEach((item) => {
        // var timecompare = this.formatTimestamp(item.dateAvailability);
        item['img_link'] = this.rtmImgLinkFiltering(item.data.images, '320x0');
        item['redirect_url'] = `/live/${this.lowerCaseAndRemoveSpace(
          item.longTitle
        )}`;
        store.push(item);
      });

      vm.tv_fast_channel_list = store;
    },
  },
};
</script>

<style scoped>
h1 {
  margin: 0;
  font-family: 'Bree Serif', serif;
  font-size: 36px;
}
p {
  margin-top: 20px;
  margin-bottom: 0;
  padding: 0;
  font-size: 20px;
  line-height: 1.5;
}
.tabs {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  max-width: 700px;
  background: #000;
  box-shadow: 0 48px 80px -32px rgba(0, 0, 0, 0.3);
}
.input {
  position: absolute;
  opacity: 0;
}
.label {
  width: 100%;
  padding: 16px 8px;
  background: #000;
  cursor: pointer;
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  transition: background 0.1s, color 0.1s;
}
.label:hover {
  background: #000;
}
.label:active {
  background: #000;
}
.input:focus + .label {
  z-index: 1;
}
.input:checked + .label {
  border-bottom: 2px solid #d9e021;
}
@media (max-width: 768px) {
  .label {
    width: auto;
  }
}
.panel {
  width: 100%;
  display: none;
  padding: 16px 0;
  position: relative;
  overflow: hidden;
}
@media (max-width: 768px) {
  .panel {
    order: 99;
  }
}
.input:checked + .label + .panel {
  display: block;
}
</style>
